import React, { useContext, useState, useCallback } from 'react';
import uuidv4 from 'uuid/v4';
import * as _ from 'lodash';

export interface IDownloaderContext {
  downloads: Download[];
  addDownload: Function;
}

export interface Download {
  uuid?: string;
  progress: number;
  name: string;
  action?: Function;

}
/**
 * starts a download and show some progress 
 * 
 */
export const DownloaderContext = React.createContext<IDownloaderContext>({
  downloads: [],
  addDownload: () => {}
});


export const DownloaderProvider: React.FC = ({ children }) => {
  const [ downloads, setDownloads ] = useState<IDownloaderContext['downloads']>([]);

  const setDownloadIntern = useCallback(async (d: Download) => {
    if (d.uuid === undefined) {
      d.uuid = uuidv4();
    }
    console.log('add download to list', downloads);
    setDownloads(dlist => [...dlist, d]);
    try{
      if(d.action) {  
        const result = await d.action();
        console.log('result', result);
      }
    } catch(e) {
      console.log('error in promise');
    }
    setDownloads(dlist => {
      _.remove(dlist, (current) => {
        return current.uuid === d.uuid;
      })
      return [...dlist];
    });
    
    

  },[]);

  const downloaderContext: IDownloaderContext = {
    downloads: downloads,
    addDownload: setDownloadIntern,
  }
  
  return (
    <DownloaderContext.Provider value={downloaderContext}>
      {children}
    </DownloaderContext.Provider>
  );
}


export const DownloaderConsumer = DownloaderContext.Consumer;


export const useDownloaderContext = () => useContext(DownloaderContext);
